import { Box } from "@chakra-ui/react";
// import DashboardLayout from "../../layouts/Dashboard.layout";
import {
  // DashboardFooter,
  DashboardLeft,
} from "./sections";
import { Outlet } from "react-router-dom";
import { useMenu } from "../../hooks/useMenu";

const Dashboard = () => {
  const { menu } = useMenu();

  return (
    <Box>
      <Box display={{ base: "block", lg: "none" }}>
        <Outlet />
        {/* <DashboardLayout.Small Footer={<DashboardFooter />} /> */}
      </Box>
      <Box position={"relative"} display={{ base: "none", lg: "flex" }}>
        <Box
          bg={"background"}
          w={"15rem"}
          position="fixed"
          zIndex={"sticky"}
          h="100%"
        >
          <DashboardLeft menuItems={menu} />
        </Box>
        <Box ml={{ base: 0, md: "20rem", lg: "15rem" }} width={"full"}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
